import BasketView from './BasketView';
import SharedDispatcher from '../others/SharedDispatcher';
import HeaderTabView from './HeaderTabView.js';
import getBasketTabContent from '../../api/headerTab/getBasketTabContent.js';

export default class extends HeaderTabView {
  _pageIndex = 0;
  _basketView = null;

  constructor() {
    super({ name, fetch: getBasketTabContent });
  }

  /**
   * Constructor
   */
  initialize(options) {
    this._clearHtmlPropertyThenRefreshView = this._clearHtmlPropertyThenRefreshView.bind(this);

    super.initialize(options);

    this.listenTo(SharedDispatcher, 'headerTabBasketView:refresh', this._clearHtmlPropertyThenRefreshView);
    this.listenTo(SharedDispatcher, 'headerTabBasketView:updatePageIndex', this._updatePageIndex);
  }

  /**
   * Clear html model property and activate a re-render.
   * It is called by headerTabBasketView:refresh event bus.
   */
  _clearHtmlPropertyThenRefreshView() {
    this.load();
  }

  _updatePageIndex(options) {
    this._pageIndex = options.pageIndex;
  }

  _renderContent(content) {
    super._renderContent(content);

    this._basketView?.dispose();

    var $basket = this.$('.js-Basket');

    if ($basket.length) {
      this._basketView = new BasketView({ el: $basket, pageIndex: this._pageIndex });
      this._basketView.render();
    }
  }
}
